import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const QuestionMarkCircleLinear = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path
                        d="M12.0003 13.66V11.99C13.2303 11.99 14.2203 10.99 14.2203 9.77005C14.2203 8.55005 13.2203 7.55005 12.0003 7.55005C10.7803 7.55005 9.78027 8.54005 9.78027 9.77005"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 16C12 16 12 16 12 16.0001C12 16.0001 12 16.0001 12 16.0001C12 16.0001 12 16.0001 12 16.0001C12 16 12 16 12 16Z"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill="none" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
